/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { Endpoint } from '../index';
import { z, ZodTypes } from '../zod';

export const SystemConfigGet = {
  id: 'system-config.get',
  tag: 'Common',
  summary: 'System configuration',
  description: 'Get system configuration',
  method: 'get',
  flags: { isAuthorized: true },
  route: () => `/system-config`,
  response: {
    200: {
      description: 'successful',
      content: {
        'application/json': {
          schema: z.strictObject({
            id: ZodTypes.Id.optional(),
            smtpHost: z.string().nullable().optional(),
            smtpPort: z.number().nullable().optional(),
            smtpSecure: z.boolean().nullable().optional(),
            smtpUser: z.string().nullable().optional(),
            smtpPass: z.string().nullable().optional(),
            smtpFromEmail: z.string().nullable().optional(),
            enquiryEmails: z.string().optional(),
            allowServiceCreation: z.boolean(),
            showInstanceCost: z.boolean(),
            showSupportCost: z.boolean(),
            minCpuLimit: z.number().nullable().optional(),
            maxCpuLimit: z.number().nullable().optional(),
            minMemoryLimit: z.number().nullable().optional(),
            maxMemoryLimit: z.number().nullable().optional(),
            minStorageLimit: z.number().nullable().optional(),
            maxStorageLimit: z.number().nullable().optional(),
            minReplicasLimit: z.number().optional(),
            maxReplicasLimit: z.number().max(10).optional(),
            currency: z.string().max(3),
            cpuPricePerMonth: z.number(),
            memoryPricePerMonth: z.number(),
            storagePricePerMonth: z.number(),
            cpuRequestToLimitMultiplier: z.number().min(1).optional(),
            resourceUsageCpuThreshold: z.number().min(0).max(1),
            resourceUsageMemoryThreshold: z.number().min(0).max(1),
            enquiryEmailLanguage: ZodTypes.Language.optional(),
            createdAt: z.date().optional(),
            active: z.boolean().optional(),
            emailAddress: z.string().nullish(),
            emailToken: z.string().nullish(),
            imprint: z.string(),
            services: z.record(ZodTypes.ServiceType, z.boolean()),
          }),
        },
      },
    },
  },
} as const satisfies Endpoint;
